import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
import MUIAlert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import { palette } from "../Theme/Palette/paletteTheme.js";
import { Typography } from "../Typography/index.js";
import { Palette } from "../constants.js";
import "@mui/material/Typography";
function getAlertColor(severity) {
  switch (severity) {
    case "info":
      return Palette.ALERT_INFO;
    case "error":
      return Palette.ALERT_ERROR;
    case "success":
      return Palette.ALERT_SUCCESS;
    case "warning":
      return Palette.ALERT_WARNING;
    default:
      return Palette.ALERT_INFO;
  }
}
function getAlertIcon(severity) {
  const color = getAlertColor(severity);
  switch (severity) {
    case "info":
      return /* @__PURE__ */ jsx(InfoOutlinedIcon, { sx: {
        color
      } });
    case "error":
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { sx: {
        color
      } });
    case "success":
      return /* @__PURE__ */ jsx(CheckCircleOutlineIcon, { color: "success" });
    case "warning":
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { sx: {
        color: Palette.SUNBURN
      } });
    default:
      return /* @__PURE__ */ jsx(InfoOutlinedIcon, { color: "info" });
  }
}
function getAlertBGColor(severity) {
  switch (severity) {
    case "info":
      return Palette.ALERT_INFO_LIGHTER;
    case "error":
      return Palette.ALERT_ERROR_LIGHTER;
    case "success":
      return Palette.ALERT_SUCCESS_LIGHTER;
    case "warning":
      return Palette.ALERT_WARNING_LIGHTER;
    default:
      return Palette.ALERT_INFO_LIGHTER;
  }
}
const Alert = React__default.forwardRef(function Alert2({
  title,
  description,
  severity = "info",
  onClose,
  open,
  sx,
  ...props
}, ref) {
  return open === void 0 || open && !!onClose ? /* @__PURE__ */ jsxs(MUIAlert, { ref, severity, icon: getAlertIcon(severity), sx: {
    backgroundColor: getAlertBGColor(severity),
    border: 0,
    ...sx
  }, ...props, children: [
    /* @__PURE__ */ jsxs(Box, { sx: {
      display: "flex",
      alignItems: "start",
      justifyContent: "space-between",
      width: "100%",
      mt: "4px"
    }, children: [
      /* @__PURE__ */ jsx(AlertTitle, { children: /* @__PURE__ */ jsx(Typography, { color: getAlertColor(severity), variant: "subtitle2", fontWeight: "bold", children: title }) }),
      !!onClose && /* @__PURE__ */ jsx(IconButton, { sx: {
        mt: "-8px",
        padding: "5px"
      }, onClick: onClose, "aria-label": "close alert", children: /* @__PURE__ */ jsx(CloseIcon, { sx: {
        color: palette.neutral.dark
      } }) })
    ] }),
    !!description && /* @__PURE__ */ jsx(Typography, { variant: "caption", fontWeight: "normal", color: getAlertColor(severity), children: description })
  ] }) : /* @__PURE__ */ jsx(Box, { ref });
});
export {
  Alert
};
//# sourceMappingURL=index.js.map
